export enum SettingsContributionType {
  TOTAL_BET_AMOUNT_RM = 'total_bet_amount_rm',
  TOTAL_BET_AMOUNT_RM_BM = 'total_bet_amount_rmbm',
  TOTAL_ROUND_COUNT_RM = 'total_round_count_rm',
  TOTAL_ROUND_COUNT_RM_BM = 'total_round_count_rmbm',
}
